import React from "react";

const ICON_SRC = "/brand/lex-counsel-triskelion-128.png";
const ICON_SRC_SET = [
  "/brand/lex-counsel-triskelion-64.png 64w",
  "/brand/lex-counsel-triskelion-128.png 128w",
  "/brand/lex-counsel-triskelion-256.png 256w",
  "/brand/lex-counsel-triskelion-512.png 512w",
].join(", ");

type LexCounselTriskelionProps = {
  /** Rendered square size in CSS pixels */
  size?: number;
  className?: string;
};

/**
 * Lex Counsel triskelion — multi-DPI PNG (64–512px). Regenerate: `node scripts/process-lex-triskelion.mjs`
 */
export default function LexCounselTriskelion({
  size = 28,
  className = "",
}: LexCounselTriskelionProps) {
  const px = Math.round(size);

  return (
    <img
      src={ICON_SRC}
      srcSet={ICON_SRC_SET}
      sizes={`${px}px`}
      width={px}
      height={px}
      alt=""
      aria-hidden
      draggable={false}
      decoding="sync"
      className={`lex-counsel-triskelion block shrink-0 max-w-none object-contain ${className}`}
      style={{ width: px, height: px }}
    />
  );
}
